import React, { useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography
} from '@mui/material';
import { Add as AddIcon, Groups as GroupsIcon } from '@mui/icons-material';
import api from '../services/api';

export default function NoOrganization() {
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [openJoinDialog, setOpenJoinDialog] = useState(false);
  const [newOrgName, setNewOrgName] = useState('');
  const [newOrgDescription, setNewOrgDescription] = useState('');
  const [isCreating, setIsCreating] = useState(false);

  const handleCreateOrganization = async () => {
    if (!newOrgName.trim()) return;

    setIsCreating(true);
    try {
      const response = await api.createOrganization({
        name: newOrgName.trim(),
        description: newOrgDescription.trim() || undefined,
      });
      if (response.success) {
        window.location.reload();
      }
    } catch (error) {
      console.error('Error creating organization:', error);
      alert('Failed to create organization. Please try again.');
    } finally {
      setIsCreating(false);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 'calc(100vh - 120px)',
        width: '100%',
        py: 4,
        px: 2,
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, maxWidth: 360, width: '100%' }}>
        <Button
          variant="contained"
          size="large"
          fullWidth
          startIcon={<AddIcon />}
          onClick={() => setOpenCreateDialog(true)}
        >
          Create an organization
        </Button>
        <Button
          variant="outlined"
          size="large"
          fullWidth
          startIcon={<GroupsIcon />}
          onClick={() => setOpenJoinDialog(true)}
        >
          Join an organization
        </Button>
      </Box>

      <Dialog open={openCreateDialog} onClose={() => !isCreating && setOpenCreateDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Create organization</DialogTitle>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (newOrgName.trim() && !isCreating) handleCreateOrganization();
          }}
        >
          <DialogContent>
            <TextField
              fullWidth
              label="Organization name"
              value={newOrgName}
              onChange={(e) => setNewOrgName(e.target.value)}
              margin="normal"
              autoFocus
              required
              helperText="Your company or team name"
              disabled={isCreating}
            />
            <TextField
              fullWidth
              label="Description (optional)"
              value={newOrgDescription}
              onChange={(e) => setNewOrgDescription(e.target.value)}
              margin="normal"
              multiline
              minRows={2}
              disabled={isCreating}
            />
          </DialogContent>
          <DialogActions>
            <Button
              type="button"
              onClick={() => {
                setOpenCreateDialog(false);
                setNewOrgName('');
                setNewOrgDescription('');
              }}
              disabled={isCreating}
            >
              Cancel
            </Button>
            <Button type="submit" variant="contained" disabled={!newOrgName.trim() || isCreating}>
              {isCreating ? 'Creating…' : 'Create'}
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      <Dialog open={openJoinDialog} onClose={() => setOpenJoinDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Join an organization</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ pt: 0.5 }}>
            To access your organization in TimeSentinel, ask your TimeSentinel administrator to invite you by email or
            add you to their organization. If you were sent an invitation, check your inbox for the link.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenJoinDialog(false)} variant="contained">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
